// @givmo/app-admin — every word the assistant panel says in this portal.
//
// ══ THIS FILE IS THE APPROVED COPY, VERBATIM ═══════════════════════════════════════════════════
//
// The strings below are the operator-approved mockup's bytes, unchanged — including its STRAIGHT
// apostrophes (`'`), which differ from the typographic apostrophe (`’`) the rest of this portal uses
// ("We couldn’t save your changes."). That divergence is deliberate here: the consent wording was
// ratified as given, and re-punctuating approved copy is not a styling decision to take quietly.
// `assistant-copy-freeze.test.ts` pins the strings so a later tidy-up cannot silently restyle them.
//
// ══ WHAT IS NOT HERE, AND WHY ══════════════════════════════════════════════════════════════════
//
// The BODY of the acceptance card and of the first-use notice is NOT in this file and must never be.
// The server serves the instrument's canonical bytes and the acceptance echoes their hash, so copy
// compiled into the client would be accepted-but-not-displayed the moment the registry's version
// moved. Everything here is the chrome around that body.

import type { AssistantVocab } from '@givmo/assistant-panel';

/** The user-facing name, everywhere it appears (D-EP-43). Never shortened to "Assistant". */
export const ASSISTANT_NAME = 'Givmo Assistant';

export function assistantVocab(): AssistantVocab {
  return {
    productName: ASSISTANT_NAME,
    composerPlaceholder: 'Ask about your giving data…',
    emptyTitle: "Ask about your company's giving.",
    emptyBody:
      "I can read what's in your portal — matches, budget, charities, fundraisers — and draft text for you to use.",
    copyAction: 'Copy',
    insertAction: 'Insert into description',
    failedLine: "We couldn't get a reply.",
    failedRetry: 'Try again',
    stopLabel: 'Stop',
    sendLabel: 'Send',
    consentTitle: `Turn on ${ASSISTANT_NAME} for {org}`,
    consentScopeLine:
      "You're turning this on for {org}. Any of your company's admins will be able to use it.",
    consentDecline: 'Not now',
    consentAccept: 'Turn on assistant',
    noticeScopeLine: '{org} turned this on.',
    noticeDismiss: 'Got it.',
    // A Member cannot bind the company, so this is a statement of fact and not an instruction they
    // can act on — no button, no link, no "contact your admin" flow they would have to go and find.
    consentBlockedLine: 'An Owner needs to turn this on for {org}.',
    unavailableLine: "Givmo Assistant isn't available here yet.",
    policyLinkPhrase: 'Privacy Policy',
  };
}
